import { LessonLike } from '@/helpers/types/LessonLike';

export const selectAll = <T extends { lessons: LessonType[] }, LessonType extends LessonLike>(
    lessonContainers: T[],
    checkedLessons: LessonType[]
): LessonType[] => {
    const checkedIds = new Set(checkedLessons.map((l) => l.id));
    const result = [...checkedLessons];

    const selectLessons = (lessons: LessonType[]) => {
        lessons.forEach((lesson) => {
            if (!checkedIds.has(lesson.id)) {
                checkedIds.add(lesson.id);
                result.push(lesson);
            }
            if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
                selectLessons(lesson.sub_lessons as LessonType[]);
            }
        });
    };

    lessonContainers.forEach((container) => {
        selectLessons(container.lessons);
    });

    return result;
};

export const deselectAll = <T extends { lessons: LessonType[] }, LessonType extends LessonLike>(
    lessonContainers: T[],
    checkedLessons: LessonType[]
): LessonType[] => {
    const idsToRemove = new Set<string | number>();

    const collectIds = (lessons: LessonType[]) => {
        lessons.forEach((lesson) => {
            idsToRemove.add(lesson.id);
            if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
                collectIds(lesson.sub_lessons as LessonType[]);
            }
        });
    };

    lessonContainers.forEach((container) => {
        collectIds(container.lessons);
    });

    return checkedLessons.filter((lesson) => !idsToRemove.has(lesson.id));
};
